import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/ui/empty-state";

// Tournaments are retired: they fed no time series and answered no question the
// tracking plan doesn't answer better. This route stays for old bookmarks;
// historical tournament data remains readable through the API and Activity.
export function TournamentView() {
  return (
    <EmptyState
      icon={Trophy}
      title="Tournaments are retired"
      description="Ranking questions now have a durable answer: topic spaces score every brand through the same lens each week, and Brand Health shows who leads in every topic — no one-off brackets needed. Past tournament results remain in your activity history."
      action={
        <div className="flex items-center gap-3">
          <Link to="/app/health"><Button>Open Brand Health</Button></Link>
          <Link to="/app/topics/new"><Button variant="secondary">New topic space</Button></Link>
        </div>
      }
    />
  );
}
